import React from 'react';
import { useStore } from '@nanostores/react';
import { HotEditPanel, hotEditStore } from '@ideoz/workbench';
import { Button } from '@ideoz/ui';
import { X } from 'lucide-react';

/**
 * Hot edit inspector filling the conversation column (replaces messages + composer while active).
 */
export function HotEditConversationStrip({ prototypePanelVisible }: { prototypePanelVisible: boolean }) {
  const mode = useStore(hotEditStore.mode);
  const sel = useStore(hotEditStore.selection);
  const api = useStore(hotEditStore.bridgeApi);

  if (!prototypePanelVisible || !mode || !sel) return null;

  return (
    <div className="flex flex-col flex-1 min-h-0 h-full overflow-hidden">
      <div className="flex items-center justify-end gap-2 px-2 py-1 shrink-0">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 text-[11px] gap-1"
          onClick={() => api?.exitHotEditMode()}
        >
          <X className="h-3.5 w-3.5" aria-hidden />
          Close inspector
        </Button>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <HotEditPanel className="min-h-0 h-full" showCloseInHeader={false} />
      </div>
    </div>
  );
}
